export const projects = [
  {
    title: "Meliora Impact",
    description:
      "A website designed for a charitable donations website, assigned as the final exam of year 2, a group project with six other members",
    image: "/projectImages/smidig.png",
    source: "https://github.com/a-baade/pro201-smidig",
    visit: "https://pro201-smidig.herokuapp.com/",
    id: 0,
  },

  {
    title: "Reise Application",
    description:
      "A speculative travel application, designed in Figma for a mobile development class along side three others",
    image: "/projectImages/reise.png",
    source:
      "https://www.figma.com/file/ZNWO4gfmCPClqYOlnbfNiO/Skisse-til-reiseapp?node-id=0%3A1",
    id: 1,
  },
  {
    title: "Reverse Image Search",
    description:
      "A reverse image search app, using Xml for the layout and kotlin for the logic. The API sends a cropped image to a search engine and returns the results. These images are then saved locally via SQLite",
    image: "/projectImages/reverse.png",
    source: "https://github.com/a-baade/PRG208_Android_Programming_Exam",
    id: 2,
  },
  {
    title: "Portfolio website",
    description:
      "A React based website acting as my personal portfolio, CV and project portal and demonstration of my frontend skills in html, css and js, with",
    image: "/projectImages/cv.png",
    visit: "https://andreas-baade.netlify.app/",
    source: "https://github.com/a-baade/CVWebsite",
    id: 3,
  },
  {
    title: "Face Recognition site",
    description:
      "A face recognition app built in React with the use of the ClarifaiAPI, with a register, login and making use of Redis, Docker and AWS",
    image: "/projectImages/facerecog.PNG",
    source: "https://github.com/a-baade/face-recog-app",
    id: 4,
  },
  {
    title: "Weather forecast",
    description:
      "A weather forecast app built in next.js using typescript and tailwind css. Fetching from openweathers api to display relevant info and icons",
    image: "/projectImages/weather.PNG",
    visit: "https://weather-sigma-orcin.vercel.app/",
    source: "https://github.com/a-baade/weather",
    id: 5,
  },
  {
    title: "BlackJack C#",
    description:
      "A game of Blackjack created in C#, improved recreation of a old school project",
    image: "/projectImages/BlackJack.PNG",
    source: "https://github.com/a-baade/BlackJack",
    id: 6,
  },
  {
    title: "Algorithm Visualizer",
    description:
      "A algorithm visualization site made in Next.js, displaying sorting algorithms to visually represent what they are doing",
    image: "/projectImages/alogvis.PNG",
    visit: "https://algovisualizer-fawn.vercel.app/",
    source: "https://github.com/a-baade/AlgoVisualizer",
    id: 7,
  },
  {
    title: "Pomodoro Chrome Extension",
    description:
      "A countdown timer with automatic session switching between work and break sessions",
    image: "/projectImages/pomodoro.PNG",
    source: "https://github.com/a-baade/pomodoro_timer",
    id: 8,
  },
  {
    title: "Application Tracker",
    description:
      "NextJS, for tracking of applications. Making use serverSide rendering, server actions, Oauth, form submission for submition, updating data. Prisma(ORM) for database managment, shadcn UI compoenets.",
    image: "/projectImages/apptrack.PNG",
    visit: "https://jobsdashboard.vercel.app/",
    source: "https://github.com/a-baade/jobsdashboard",
    id: 9,
  },
];
